// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Rhvbr","field":"styles_field__1cq6M","fieldCol":"styles_fieldCol__1RsY_","diffCol":"styles_diffCol__3w9eS","diff":"styles_diff__3UhEX"};